import styled from "styled-components";
export const NavImageStyled = styled.img `
  height: ${(props) => props.height};
`;
//# sourceMappingURL=NavImageStyles.js.map